// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import cn from 'classnames';
import {Textarea} from '../../lib/textarea';
import {Settings_context} from '../../settings_ctx';
import styles from './survey.module.less';

interface i_survey_comment_props extends i_survey_comment {
    save: t_survey_save;
}
export const Survey_comment = (props: i_survey_comment_props)=>{
    const {theme} = useContext(Settings_context);
    const {id, text, label, placeholder, save} = props;
    const [msg, set_msg] = useState('');
    const on_edit = value=>{
        set_msg(value);
        save(id, ['comment'], msg);
    };
    const cls = cn(styles.survey_comment);
    return <div className={cls}>
      {(text || label) && <div className={styles.text}>
        {text && <p className={theme.bold}>{text}</p>}
        {label && <p className={theme.p2}>{label}</p>}
      </div>}
      <Textarea placeholder={placeholder} on_change={on_edit} value={msg}
        min_height={140}/>
    </div>;
};
